var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "28px",
    viewBox: "0 0 30 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Error",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8717308,0.696749574 L29.1871333,24.5119863 L29.1871333,24.5119863 C29.4566558,24.9940403 29.2843651,25.6033134 28.8023111,25.872836 C28.6531751,25.9562198 28.4851611,26 28.3142974,26 L1.6834924,26 L1.6834924,26 C1.13120765,26 0.683492402,25.5522847 0.683492402,25 C0.683492402,24.8291363 0.727272595,24.6611223 0.810656441,24.5119863 L14.1260589,0.696749574 L14.1260589,0.696749574 C14.3955814,0.214695583 15.0048546,0.0424047947 15.4869086,0.311927327 C15.6482919,0.4021588 15.7814994,0.53536625 15.8717308,0.696749574 Z",
    id: "Triangle",
    stroke: "#FF6000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1,17.8 C15.72,17.8 16.24,17.32 16.28,16.68 L16.56,10.06 C16.6,9.2 15.92,8.52 15.08,8.52 C14.26,8.52 13.58,9.22 13.62,10.06 L13.92,16.68 C13.96,17.32 14.46,17.8 15.1,17.8 Z M13.5,20.6 C13.5,21.46 14.22,22.2 15.1,22.2 C15.98,22.2 16.7,21.46 16.7,20.6 C16.7,19.72 15.98,18.98 15.1,18.98 C14.22,18.98 13.5,19.72 13.5,20.6 Z",
    id: "!",
    fill: "#FF6000"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangle);
export default __webpack_public_path__ + "static/media/error-triangle.cbfb3778f280796641f1b7e9ac8f6f18.svg";
export { ForwardRef as ReactComponent };